import { Outlet } from 'react-router-dom'
import { Logo } from '@/components/shared/logo'

export function AuthLayout() {
  return (
    <div className="min-h-screen flex">
      {/* Left side - Branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-primary flex-col justify-between p-12">
        <div className="inline-flex self-start rounded-lg bg-white p-2">
          <Logo className="h-12" />
        </div>

        <div className="space-y-6">
          <h1 className="text-4xl font-bold text-primary-foreground leading-tight">
            Where Every Tail Gets the VIP Treatment
          </h1>
          <p className="text-lg text-primary-foreground/80">
            Sacramento's trusted pet daycare and boarding — with easy online
            booking, real-time updates, and a team that treats your dogs like family.
          </p>
        </div>

        <p className="text-sm text-primary-foreground/60">
          &copy; {new Date().getFullYear()} River Dogs Resort. All rights reserved.
        </p>
      </div>

      {/* Right side - Auth forms */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <div className="lg:hidden flex items-center justify-center mb-8">
            <div className="inline-flex rounded-2xl bg-muted p-4">
              <Logo className="h-12" />
            </div>
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  )
}
